import script from "./NavDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NavDrawer.vue?vue&type=script&setup=true&lang=js"

import "./NavDrawer.vue?vue&type=style&index=0&id=1b090a0c&lang=css"

const __exports__ = script;

export default __exports__